import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Divider, FullPageWrapper } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import type { IResponseReview } from 'entities/Review/api/types'
import { ReviewAnalyticsStore } from 'pages/reviews/store'
import { ReviewAnalyticsContext } from 'pages/reviews/context'
import { ReviewsPath } from 'pages/reviews'
import { ReviewAnalyticsHeader } from 'pages/reviews/pages/viewReview/ui/ReviewAnalyticsHeader/ReviewAnalyticsHeader'
import { ReviewAnalyticsCalendar } from 'pages/reviews/pages/viewReview/ui/ReviewAnalyticsCalendar/ReviewAnalyticsCalendar'
import { ReviewStatistics } from 'pages/reviews/pages/viewReview/ui/ReviewStatistics/ReviewStatistics'
import { ReviewContactsTable } from 'pages/reviews/pages/viewReview/ui/ReviewContactsTable/ReviewContactsTable'

type IViewReviewContentProps = {
  review: IResponseReview
}

export const ViewReviewContent = ({ review }: IViewReviewContentProps) => (
  <ViewReviewContentInner key={review.id} review={review} />
)

const ViewReviewContentInner = observer(({ review }: IViewReviewContentProps) => {
  const [store] = useState(
    () =>
      new ReviewAnalyticsStore(review, () =>
        uiStore.changeRouteViaVue({ path: `/${ReviewsPath.root}` })
      )
  )

  useEffect(() => {
    store.init()

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <ReviewAnalyticsContext.Provider value={store}>
      <FullPageWrapper>
        <ReviewAnalyticsHeader />
        <Box display={'flex'} flexDirection={'column'} flex={1}>
          <ReviewAnalyticsCalendar />
          <ReviewStatistics />
          <Divider
            sx={{
              margin: '9px 20px 30px',
              borderColor: 'var(--border-neutral-default)',
            }}
          />
          <ReviewContactsTable />
        </Box>
      </FullPageWrapper>
    </ReviewAnalyticsContext.Provider>
  )
})
